<template>
  <div
    v-if="openButton"
    class="cursor-pointer"
    tabindex="0"
    @click="open = true"
    @touchstart="open = true"
    @keydown="e => keyHandler(e, [], () => open = true)"
  >
    <div>
      <SfIconInfo
        size="base"
      />
    </div>
  </div>

  <div
    v-if="open"
    class="fixed inset-0 z-40 h-screen w-screen overflow-hidden bg-neutral-500/20 transition-opacity"
  />
  <transition
    enter-active-class="transition duration-500 ease-in-out"
    leave-active-class="transition duration-500 ease-in-out"
    enter-from-class="translate-x-full"
    enter-to-class="translate-x-0"
    leave-from-class="translate-x-0"
    leave-to-class="translate-x-full"
  >
    <SfDrawer
      ref="drawerRef"
      v-model="open"
      placement="right"
      class="fixed z-50 flex w-[500px] flex-col bg-white p-4 mobile:w-full"
    >
      <header
        v-if="title"
        class="flex items-center justify-between border-b pb-4"
      >
        <h3 class="text-xxl text-neutral-700">
          {{ $t(title) }}
        </h3>
        <KikButton
          square
          variant="tertiary"
          @click="open = false"
          @touchstart="open = false"
        >
          <SfIconClose class="fill-neutral-500 text-neutral-500" />
        </KikButton>
      </header>
      <div
        class="h-full overflow-y-auto py-4"
        @wheel.prevent
        @touchmove.prevent
      >
        <div
          class="text-left text-xl font-normal text-neutral-700"
          v-html="legalText"
        />
      </div>
      <footer class="mt-auto border-t pt-4">
        <KikButton
          class="w-full"
          @click="open = false"
          @touchstart="open = false"
        >
          {{ $t('Close') }}
        </KikButton>
      </footer>
    </SfDrawer>
  </transition>
</template>

<script lang="ts" setup>
import { SfIconInfo, SfDrawer, useTrapFocus } from '@storefront-ui/vue';
import keyHandler from '~/helpers/a11y/keyHandler';

type Props = {
  legalText: string;
  title: string;
  openButton?: boolean;
  isOpen?: boolean;
};
const { title, legalText, openButton = true, isOpen = false } = defineProps<Props>();

const emit = defineEmits(['onVisibilityChange']);

const open = ref(false);

watch(() => isOpen, (value) => {
  open.value = value;
});

const drawerRef = ref();

useTrapFocus(drawerRef, { activeState: open });

watch(open, (value) => {
  emit('onVisibilityChange', value);
});
</script>
